import { Button } from '@honeyscience/honey-ui-toolkit';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import Store from 'mockStores/components/stores/Store';
import { LINK_TO_PATH_MAP } from 'mockStores/lib/constants';
import { LinkNames } from 'mockStores/lib/types';

const useStyles = createUseStyles({
  buttonCopy: {
    paddingLeft: '8px',
  },
  container: {
    display: 'flex',
  },
  paypalCheckoutButton: {
    display: 'flex',
    marginTop: '8px',
    padding: '8px',
  },
});

function LegacyPayPal(): ReactElement {
  const classes = useStyles();

  const buttonCopy = <div className={ classes.buttonCopy }>Legacy Checkout</div>;

  const renderButton = () => (
    <Button
      id="checkoutWithPayPal"
      buttonType="third"
      to={ LINK_TO_PATH_MAP[LinkNames.LegacyPayPalResult].to }
      isFlexible
      className={ classes.paypalCheckoutButton }
      icon="social-paypal-24"
      copy={ buttonCopy }
      size={ 48 }
    />
  );

  return (
    <Store
      button={ renderButton() }
      title="Honey Checkout Mock Store (Legacy PayPal Button)"
      description="The Legacy PayPal button is a simple button which the extension selects and clicks."
    />
  );
}

export default LegacyPayPal;
